export default __webpack_public_path__ + "static/media/bg-line.50363009.svg";